import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useEffect, useRef } from "react";
import { CustomGridColDef } from "../gridColumnDefs";

const useStyles = makeStyles((theme) => ({
    text: {
        width: "100%",
        padding: theme.spacing(1, 0, 1, 0),
        pointerEvents: "none",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflowX: "hidden"
    },
    wrapText: {
        overflowWrap: "break-word",
        whiteSpace: "normal"
    },
}));

export default function WrapTextCell({ field, id, colDef, formattedValue, value }: GridRenderCellParams)
{
    const ref = useRef<HTMLSpanElement | null>(null);
    const classes = useStyles();
    const { onSetHeight, textWrap } = colDef as unknown as CustomGridColDef;
    let child = formattedValue || value;

    if (typeof child === "object") {
        child = JSON.stringify(child);
    }
    useEffect(() =>
    {
        if (ref.current)
        {
            const height = ref.current.clientHeight;
            onSetHeight(id as string, field, height);
        }
    });
    return (
        <Box title={child}>
            <Typography ref={ref} className={`${classes.text} ${textWrap ? classes.wrapText : ""}`} variant={"body2"}>
                {child}
            </Typography>
        </Box>
    );
}